<template>
    <fragment @mouseover="hover = true" @mouseleave="hover = false">
        <div class="relative mx-2 " v-if="false">
            <div
                class="right-0 px-4 py-1 text-xs text-white bg-black rounded bottom-full "
            >
                <slot name="tip"></slot>545454
                <svg
                    class="absolute left-0 h-2 ml-3 text-black top-full "
                    x="0px"
                    y="0px"
                    viewBox="0 0 255 255"
                    xml:space="preserve"
                >
                    <polygon
                        class="fill-current"
                        points="0,0 127.5,127.5 255,0"
                    />
                </svg>
            </div>
        </div>

        <slot></slot>
    </fragment>
</template>

<script>
export default {
    data() {
        return {
            hover: false
        };
    }
};
</script>

<style>
.bottom-full {
    bottom: 100%;
}
.top-full {
    top: 100%;
}
</style>
